import request from './request';

export function getWorkerStatus() {
  return request({
    url: '/reference-data-stream/worker-status',
    method: 'get'
  });
}

/**
 * 提交 CSV 内容，提取参考数据流范围
 * @param {string} csvContent - CSV 文件文本内容
 * @param {string} csvFileName - 原始文件名（用于日志记录）
 * @param {number} csvLineCount - CSV 行数（用于日志记录）
 */
export function extractReferenceDataStream(csvContent, csvFileName = '', csvLineCount = 0) {
  return request({
    url: '/reference-data-stream/extract',
    method: 'post',
    data: { csv_content: csvContent, csv_file_name: csvFileName, csv_line_count: csvLineCount }
  });
}

export function getReferenceDataStreamTask(taskId) {
  return request({
    url: `/reference-data-stream/tasks/${taskId}`,
    method: 'get'
  });
}

export function getReferenceDataStreamLogs(params = {}) {
  return request({
    url: '/reference-data-stream/logs',
    method: 'get',
    params
  });
}

export function getReferenceDataStreamLogById(id) {
  return request({
    url: `/reference-data-stream/logs/${id}`,
    method: 'get'
  });
}
